export { baseButtonPropDefs as iconButtonPropDefs } from './_internal/base-button.props.js';
